"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListingFeaturesFilter = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _parseSlugs = require("../../utils/parse-slugs");
var _multiValueSearchQueryField = require("../multi-value-search-query-field");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ListingFeaturesFilter extends _multiValueSearchQueryField.MultiValueSearchQueryField {
  get validListingTypes() {
    return _node.AllExceptBusinessListingTypeKeys;
  }
  constructor(searchOptions, value) {
    var available = (0, _node.getPropertyFeatureForType)(searchOptions.listingType).map(item => item.name).map(key => _node.PropertyFeature[key]);
    super(searchOptions, available, value);
    _defineProperty(this, "urlSlug", ListingFeaturesFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new ListingFeaturesFilter(searchOptions, (0, _parseSlugs.parseSlugs)(_node.PropertyFeature, q[ListingFeaturesFilter.urlSlug]));
  }
}
exports.ListingFeaturesFilter = ListingFeaturesFilter;
_defineProperty(ListingFeaturesFilter, "urlSlug", 'listingfeatures');